import apiConfig from '../apiConfig'
import axios from 'axios'

const { editMultiTcinInfo = '' } = apiConfig

export function editMultiTcinInfoService({ body }) {
  return axios.post(`${editMultiTcinInfo}`, body, {
    params: {
      key: apiConfig.apiKey,
    },
  })
}
